{
	"isGrouped": "Existem produtos sem custo cadastrado",
	"isNotGrouped": "Custo não cadastrado",
	"na": "N/A"
}
